/**
 * External links used across the brochure frontend.
 */

export const GOOGLE_MAPS_URL = 'https://maps.app.goo.gl/K7TnQsLQDqsxi68PA'

export const GOOGLE_MAPS_EMBED_URL =
  'https://www.google.com/maps?q=Albergo+Al+Gobbo%2C+Campo+San+Geremia+312%2C+30121+Venezia%2C+Italy&output=embed'
